import commonData from "../common/commonData"

import { pagesLinks, externalLinks } from "../common/links"

export default {
	firstColumn: {
		header: "Компания",
		refs: [
			pagesLinks.support,
			pagesLinks.capability.index,
			pagesLinks.price.index,
			pagesLinks.discounts.index,
			pagesLinks.shop.index,
			pagesLinks.about,
			pagesLinks.partners,
			pagesLinks.blog,
		],
		footer: "© 2022 Все права защищены",
	},
	secondColumn: {
		header: "Типы бизнеса",
		refs: [
			pagesLinks.businessTypes.coffeehouse,
			pagesLinks.businessTypes.bar,
			pagesLinks.businessTypes.cafe,
			pagesLinks.businessTypes.cookery,
			pagesLinks.businessTypes.restaurant,
			pagesLinks.businessTypes.refectory,
			pagesLinks.businessTypes.fastfood,
			pagesLinks.businessTypes.franchise,
			pagesLinks.businessTypes.foodtruck,
		],
		footer: {
			...pagesLinks.lisenceAgreement,
		},
	},
	thirdColumn: {
		header: "Клиентам",
		refs: [
			{
				text: "Наши приложения",
				href: externalLinks.appstoreAllApps,
			},
			pagesLinks.api,
			pagesLinks.contacts,
			pagesLinks.deliveryAndPayment,
		],
		footer: pagesLinks.privacyPolicy,
	},
	phone: {
		title: commonData.phone.text,
		value: commonData.phone.value,
	},
	email: commonData.emailSupport,
	vk: {
		href: externalLinks.vk,
		ariaLabel: "VK",
	},
	facebook: {
		href: externalLinks.facebook,
		ariaLabel: "Facebook",
	},
	instagram: {
		href: externalLinks.instagram,
		ariaLabel: "Instagram",
	},
	youtube: {
		href: externalLinks.youtube,
		ariaLabel: "Youtube",
	},
	researches:
		"Исследования осуществляются ООО «Квик Ресто» при грантовой поддержке Фонда «Сколково»",
	oneC: {
		link: externalLinks.oneC,
		alt: "Интеграция 1С и Quick Resto",
	},
	skolkovo: {
		link: externalLinks.skolkovo,
		alt: "Фонд Сколково",
	},
	appstore: {
		href: externalLinks.appstoreAllApps,
		ariaLabel: "Appstore",
	},
	googleplay: {
		link: externalLinks.googlePlayClientsCrm,
		alt: "Google Play Market",
	},
}
